import { render, staticRenderFns } from "./InserisciPunteggio.vue?vue&type=template&id=6917a99c&scoped=true&"
import script from "./InserisciPunteggio.vue?vue&type=script&lang=ts&"
export * from "./InserisciPunteggio.vue?vue&type=script&lang=ts&"
import style0 from "./InserisciPunteggio.vue?vue&type=style&index=0&id=6917a99c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6917a99c",
  null
  
)

component.options.__file = "InserisciPunteggio.vue"
export default component.exports